import { render } from "./ApplicationLogo.vue?vue&type=template&id=2edbda5d"
const script = {}

import exportComponent from "/home/appfloretcollegein/app.floretcollege.in/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__